import { Modal } from '@pentabd/ui';
import { ElectionSelect } from './ElectionSelect';
import { useCustomParams } from '@hooks/useCustomParams';
import { Dispatch, SetStateAction } from 'react';
import { DivisionChartItemType } from '@type/dashboard';
import { useElectionsType } from '@hooks/useElections';

interface SelectElectionModalType {
  isOpen: boolean;
  onClose: () => void;
  setDivisionChartState: Dispatch<SetStateAction<DivisionChartItemType[]>>;
  setElectionScheduleName: Dispatch<SetStateAction<string>>;
  electionsData: useElectionsType;
}

export const SelectElectionModal = ({
  isOpen,
  onClose,
  setDivisionChartState,
  setElectionScheduleName,
  electionsData,
}: SelectElectionModalType) => {
  const { setParams, searchParams } = useCustomParams();

  return (
    <Modal isOpen={isOpen} overlay={isOpen} onClose={onClose} portal={true}>
      <div className="p-20">
        <ElectionSelect
          setParams={setParams}
          searchParams={searchParams}
          setDivisionChartState={setDivisionChartState}
          onClose={onClose}
          electionsData={electionsData}
          setElectionScheduleName={setElectionScheduleName}
        />
      </div>
    </Modal>
  );
};
